<template>
    <div class="container mainContent scanqr">
      <h2>Scan QRCode</h2>
      <h4>สถานที่: {{facultyTh}}</h4>
      <h4>ชื่อกิจกรรม: {{eventDetail.name}}</h4>
      <h5>วันที่: {{eventDetail.date + " สิงหาคม 2562"}}</h5>
      <h5>รอบ: {{eventDetail.time}}</h5>
      <qrcode-stream @decode="onDecode"></qrcode-stream>
      <div class="text-left">
        <h4 class="mt-2"><span class="red">ผลการสเเกน:</span>  {{ decodeText }} </h4>
        <h4><span class="red">ผู้ลงทะเบียนที่สเเกนล่าสุด:</span> {{ lastScanUser }}</h4>
      </div>
      <hr>
      <router-link tag="a" to="/staff" class="btn btn-primary w-100 m-2">ย้อนกลับเพื่อดูกิจกรรมทั้งหมด</router-link>
    </div>
</template>

<script>
import Vue from "vue"
import BootstrapVue from "bootstrap-vue"
import axios from 'axios'
import { mapActions } from 'vuex'
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: "staffscan",
  data: () => {
    return {
      decodeText: "กำลังรอสเเกน",
      eventDetail: "",
      facultyTh: "",
      lastScanUser: "ยังไม่ได้สเเกน"
    }
  },
  methods: {
    onDecode(decodeString) {
      this.decodeText = "กำลังสเเกน"
      let regex = /(https:\/\/oph2019-kmitl-c2dac.)(firebaseapp.com|web.app)\/profile\?user=K([0-9]){5}&password=([A-Za-z0-9])+/g
      // console.log(decodeString)
      // console.log(this.$route.query)
      if (regex.test(decodeString)) {
        let params = decodeString.split('?')[1].split('&')
        let user = params[0].split('=')[1], pass = params[1].split('=')[1]
        this.lastScanUser = user

        axios({
          method: "POST",
          url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/attend",
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            "id": user,
            "faculty": this.$route.query.fac,
            "eventId": this.$route.query.eid
          }
        })
        .then((res) =>{
          if (res.data.status) {
            this.decodeText = "ผู้ลงทะเบียน " + user + " เข้าร่วมกิจกรรมเรียบร้อย"
          } else if(!res.data.status) {
            this.decodeText = "ผู้ลงทะเบียน " + user + " เคยสเเกนเข้าร่วมกิจกรรมเเล้ว หรือ ไม่ได้ลงสมัครกิจกรรมตั้งเเต่เเรก"
          }
        })
        .catch((err) => {
          console.log(err)
          this.decodeText = "กรุณาสเเกน QR code อีกรอบ"
        })
      } else {
        this.decodeText = "กรุณาสเเกน QR code ที่ถูกต้อง"
      }
    }
  },
  mounted() {
    axios({
      method: "GET",
      url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/getEventByID",
      headers: {
        faculty: this.$route.query.fac,
        id: this.$route.query.eid
      }
    })
    .then((res) => {
      this.eventDetail = res.data

      if (this.$route.query.fac == "CEN") {
        this.facultyTh = "กิจกรรมเวทีกลาง"
      } else if (this.$route.query.fac == "EN") {
        this.select_faculty = "EN"

      } else if (this.$route.query.fac == "ARCH") {
        this.facultyTh = "คณะสถาปัตยกรรมศาสตร์"

      } else if (this.$route.query.fac == "IETECH") {
        this.facultyTh = "คณะครุศาสตร์อุตสาหกรรม"

      } else if (this.$route.query.fac == "AGRO") {
        this.facultyTh = "คณะอุตสาหกรรมการเกษตร"

      } else if (this.$route.query.fac == "AGRI") {
        this.facultyTh = "คณะเทคโนโลยีการเกษตร"

      } else if (this.$route.query.fac == "SCI") {
        this.facultyTh = "คณะวิทยาศาสตร์"

      } else if (this.$route.query.fac == "IT") {
        this.select_faculty = "IT"

      } else if (this.$route.query.fac == "FAM") {
        this.facultyTh = "คณะการบริหารและการจัดการ"

      } else if (this.$route.query.fac == "LA") {
        this.select_faculty = "LA"

      } else if (this.$route.query.fac == "NANO") {
        this.facultyTh = "วิทยาลัยนาโนเทคโนโลยี"

      } else if (this.$route.query.fac == "AMI") {
        this.facultyTh = "วิทยาลัยนวัตกรรมการผลิตขั้นสูง"

      } else if (this.$route.query.fac == "MUSIC") {
        this.facultyTh = "วิทยาลัยวิศวกรรมสังคีต"

      } else if (this.$route.query.fac == "AEC") {
        this.facultyTh = "วิทยาลัยอุตสาหกรรมการบินนานาชาติ"

      } else if (this.$route.query.fac == "CHUMPHON") {
        this.facultyTh = "วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร"

      } else if (this.$route.query.fac == "MED") {
        this.facultyTh = "คณะแพทยศาสตร์"

      } else if (this.$route.query.fac == "EDU") {
        this.facultyTh = "วิทยาลัยวิจัยนวัตกรรมทางการศึกษา"

      }
    })
  },
  components: {
    QrcodeStream
  },
}
</script>

<style lang="scss" scoped>
.mainContent {
  min-height: calc(100vh - 314px) ;
}
.btn-primary {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {
  color: rgba(255,255,255,.5);
  text-decoration: none;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

.red {
  color :#ee4b23;
}

a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
}
</style>
